import {
  getAuth,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
  sendPasswordResetEmail,
} from "firebase/auth";

import store from "../../store";

import { toast } from "../../components/Toast/toast";
import { logoutUser, setUser } from "../users/index";
import { addDoc } from "firebase/firestore";
import { setCurrentUser } from "../users/actions";

// var db = firebase.firestore();
const auth = getAuth();

export function loginUser(credentials: any) {
  // console.log("attempting login");
  let email = credentials.email;

  //console.log("attempting login");
  if (email.indexOf("@") < 0) {
    email = email + "@waioratamariki.org.nz";
  }
  //console.log(email, credentials.password);
  //console.log(auth);
  return signInWithEmailAndPassword(auth, email, credentials.password)
    .then((userCredential) => {
      //console.log("returned from server")
      const user = userCredential.user;
      return user;
    })
    .catch((error) => {
      // const errorCode = error.code;
      const errorMessage = error.message;
      if (["auth/user-not-found", "auth/wrong-password"].includes(error.code)) {
        toast("Incorrect login credentials", 4000);
      } else toast("Something went wrong. Please try again", 4000);

      return false;
    });
}

export function registerUser(email: string, password: string) {
  //console.log(email);
  return createUserWithEmailAndPassword(auth, email, password)
    .then((userCred) => {
      return userCred.user;
    })
    .catch((error) => {
      // const errorCode = error.code;
      // const errorMessage = error.message;
      console.error(error);
      toast(error.message, 4000);
      return false;
    });
}

export function getCurrentUser() {
  // console.log("check current user");
  return new Promise((resolve, reject) => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        // User is signed in, see docs for a list of available properties
        // https://firebase.google.com/docs/reference/js/firebase.User
        //const uid = user.uid;
        // store.dispatch(setCurrentUser(user));
        resolve(user);
      } else {
        // User is signed out
        store.dispatch(logoutUser());
        resolve(null);
      }
      unsubscribe();
    });
  });
}

export const logout = () => {
  signOut(auth)
    .then(() => {
      store.dispatch(logoutUser());
    })
    .catch((error) => {
      console.error("There was a problem logging out: ", error.message);
    });
};

export const sendPasswordReset = (email: any) => {
  // return firebase.auth().sendPasswordResetEmail(email);
  return sendPasswordResetEmail(auth, email)
    .then(() => {
      // Password reset email sent!
      return true;
    })
    .catch((error) => {
      // const errorCode = error.code;
      const errorMessage = error.message;
      console.error(errorMessage);
      toast(
        "An error occured. If problems persist, please contact a syste admin",
        4000
      );
      return false;
    });
};

// export const deleteUserAccount = (id: any) => {
// 	deleteUser(id)
// 		.then(() => {
// 			// User deleted.
// 			console.log("user deleted");
// 		})
// 		.catch((error) => {
// 			console.log("something went wrong");
// 			console.log(error);
// 			const credential: any = promptForCredentials();

// 			reauthenticateWithCredential(id, credential)
// 				.then(() => {
// 					// User re-authenticated.
// 				})
// 				.catch((error) => {
// 					// An error ocurred
// 					// ...
// 				});
// 			// An error ocurred
// 			// ...
// 		});
// };

export const saveToken = (id: any) => {
  // if (id) {
  // 	firebase
  // 		.messaging()
  // 		.getToken()
  // 		.then((currentToken) => {
  // 			if (currentToken) {
  // 				db.collection("users")
  // 					.doc(id)
  // 					.collection("notificationTokens")
  // 					.doc(currentToken)
  // 					.set({ status: true });
  // 			} else {
  // 				requestPermission(id);
  // 			}
  // 		})
  // 		.catch((error) => {
  // 			console.log(
  // 				"The notification permission was not granted and blocked instead"
  // 			);
  // 			console.log(error);
  // 		});
  // }
  // .bind(this)).catch(function(err) {
  //   console.error('Unable to get messaging token.', err);
  //   if (err.code === 'messaging/permission-default') {
  //     this.fcmErrorContainer.innerText = 'You have not enabled notifications on this browser. To enable notifications reload the page and allow notifications using the permission dialog.';
  //   } else if (err.code === 'messaging/notifications-blocked') {
  //     this.fcmErrorContainer.innerHTML = 'You have blocked notifications on this browser. To enable notifications follow these instructions: <a href="https://support.google.com/chrome/answer/114662?visit_id=1-636150657126357237-2267048771&rd=1&co=GENIE.Platform%3DAndroid&oco=1">Android Chrome Instructions</a><a href="https://support.google.com/chrome/answer/6148059">Desktop Chrome Instructions</a>';
  //   }
  // }.bind(this));
};

export const savePushToken = (user: any, token: any) => {
  // db.collection("users")
  // 	.doc(user.uid)
  // 	.collection("notificationTokens")
  // 	.doc(token)
  // 	.set({ status: true });
};

const requestPermission = (id: any) => {
  //console.log("Requesting permission...");
  // firebase
  // 	.messaging()
  // 	.getToken()
  // 	.then(function () {
  // 		//console.log("Notification permission granted.");
  // 		saveToken(id);
  // 	});
  // .bind(this)).catch(function(err) {
  //   console.error('Unable to get permission to notify.', err);
  // });
};
